module.exports = __webpack_public_path__ + "static/media/icon_expand_wht.38efb120.svg";